<template>
    <div class="ImageListEntry">
        <div class="actions">
            <!-- <IconButton
                class="button"
                icon="angle-up"
                @click.native="$emit('moveUp')"
            /> -->
            <IconButton
                class="button"
                icon="trash-alt"
                @click.native="$emit('delete')"
            />
          <!-- <IconButton
               class="button"
               icon="angle-down"
               @click.native="$emit('moveDown')"
           /> -->
        </div>
      <ImagePreview class="preview" :imageSrc="image" @openFullScreen="changeFullScreenView"/>
      <ImageFullScreen v-if="showFullScreenImage" :imageSrc="image" @closeFullScreen="changeFullScreenView"/>
    </div>
</template>

<script>
import ImagePreview from '../ImagePreview.vue';
import IconButton from './IconButton.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faAngleUp,
    faAngleDown,
    faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import ImageFullScreen from '../ImageFullScreen'
library.add(faAngleUp, faAngleDown, faTrashAlt);

export default {
  name: 'ImageListEntry',
  components: {
    ImageFullScreen,
    ImagePreview,
    IconButton,
  },
  props: {
    image: {
      required: true,
    },
  },
  data () {
    return {
      openFullScreen: false,
      pageContent: null
    }
  },
  mounted () {
    this.pageContent = document.querySelector('.body')
  },
  beforeDestroy () {
    this.pageContent.style.overflow = null
  },
  methods: {
    changeFullScreenView() {
      this.openFullScreen = !this.openFullScreen
    },
    toggleScroll(toggle) {
      if(this.pageContent) {
        this.pageContent.style.overflow = toggle ? 'hidden' : null
      }
    },
  },
  computed: {
    showFullScreenImage() {
      this.openFullScreen ? this.toggleScroll(true) : this.toggleScroll(false)
      return this.openFullScreen
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.ImageListEntry {
    position: relative;
    display: flex;
    margin-top: 15px;

    .actions {
      flex: 0 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0px 5px;
      margin: 60px 0;
      margin-right: 10px;
      background-color: #111;
      border-radius: 20px;

      .button {
        transition: 0.1s ease-out opacity;
      }
    }

    &:hover {
        .overlay {
            opacity: 1;
        }

        .button {
            opacity: 1;
        }
    }
}
</style>
